module.exports = __webpack_public_path__ + "img/myLocation_gray.e386e5e2.svg";